<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <!-- <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title> -->
                            <v-menu :nudge-width="50" offset-y v-if="furnaces && furnaces.length > 1">
                                <v-toolbar-title slot="activator" class="d-inline-flex unselectable">
                                    <div>
                                        <span style="position: relative; bottom: -6px">{{
                                            $route.query.furnace ? `Furnace ${$route.query.furnace}` : "Select furnace"
                                        }}</span>
                                        <br />
                                        <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{ $t($route.meta.title) }}</span>
                                    </div>
                                    <v-icon dark>arrow_drop_down</v-icon>
                                </v-toolbar-title>

                                <v-list>
                                    <v-list-tile
                                        v-for="(item, index) in furnaces.filter((f) => f.short_code != ($route.query.furnace || ''))"
                                        :key="index"
                                        @click="setFurnace(item.short_code)"
                                    >
                                        <v-list-tile-title>{{ item.short_code }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <v-toolbar-title v-else class="d-inline-flex unselectable">
                                <div>
                                    <span style="position: relative; bottom: -6px">{{
                                        $route.query.furnace ? `Furnace ${$route.query.furnace}` : "No Active Furnace"
                                    }}</span>
                                    <br />
                                    <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{ $t($route.meta.title) }}</span>
                                </div>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('batch.read')"
                                ref="scan_barcode"
                                scan-object="work_orders_batch"
                                header-text="Batch Lookup"
                                @scanned="barcodeScanned($event)"
                                scan-label="i"
                                :global="true"
                            ></bc-scan-barcode>
                            <!-- <bc-btn-add
                                v-if="hasPerm('qc_inspection.create')"
                                @invoke-method="invokeMethod($event)"
                                action="showQualityControl"
                                target-ref="qc_dialog"
                            ></bc-btn-add> -->
                            <bc-btn-refresh permanent @invoke-method="dbGetQualityControl()"></bc-btn-refresh>
                            <!-- <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu> -->
                            <!-- <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="quality_control" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr :class="{ clickable: hasPerm('qc_inspection.update') }">
                                <td class="text-center pl-2 pr-0" :class="{ 'prevent-click': !hasPerm('qc_inspection.update') }">
                                    <v-btn icon @mouseup.left.stop="props.item.batch_id != last_flagged ? setQcFlag(props.item) : ''">
                                        <v-icon :large="props.item.qc_flag == '1'" :color="props.item.qc_flag == '1' ? 'blue' : 'grey'">{{
                                            props.item.qc_flag == "1" ? "check" : "close"
                                        }}</v-icon>
                                    </v-btn>
                                </td>
                                <td
                                    @mouseup.left="
                                        props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)
                                    "
                                >
                                    {{ props.item.batch_control_id }}
                                </td>
                                <td
                                    @mouseup.left="
                                        props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)
                                    "
                                >
                                    {{ props.item.customer_part_number }}
                                </td>
                                <td
                                    @mouseup.left="
                                        props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)
                                    "
                                >
                                    {{ props.item.name }}
                                </td>
                                <td
                                    @mouseup.left="
                                        props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)
                                    "
                                >
                                    {{ props.item.batch_size }}
                                </td>
                                <td
                                    @mouseup.left="
                                        props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)
                                    "
                                >
                                    {{ props.item.microstructure_display }}
                                </td>
                                <td
                                    @mouseup.left="
                                        props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)
                                    "
                                >
                                    {{ props.item.test_summary_display }}
                                </td>
                                <td class="text-center px-2" :class="{ 'prevent-click': !hasPerm('qc_inspection.update') }">
                                    <v-menu :nudge-width="50" offset-y>
                                        <v-toolbar-title slot="activator" class="d-inline-flex">
                                            <v-chip
                                                disabled
                                                round
                                                text-color="white"
                                                class="fs-14 text-center"
                                                :color="props.item.qc_summary_color"
                                                @mouseup.left.stop=""
                                            >
                                                <span style="min-width: 60px">{{ props.item.qc_summary_display }}</span>
                                                <v-icon dark class="unselectable" v-if="hasPerm('qc_inspection.update')">arrow_drop_down</v-icon>
                                            </v-chip>
                                            <!-- <div>
                                                <span style="position: relative;bottom: -6px;">{{ $t(`lang.${current_view}`)}}</span>
                                                <br/>
                                                <span style="font-size: 14px;position: relative;top: -6px; font-weight: normal">{{ $route.query.date_received || current_day }}</span>
                                            </div>
                                            <v-icon dark class="unselectable">arrow_drop_down</v-icon> -->
                                        </v-toolbar-title>

                                        <v-list>
                                            <v-list-tile
                                                v-for="(item, index) in pass_fail_hold"
                                                :key="index"
                                                @click="item.value != props.item.qc_summary ? setStatus(props.item, item) : ''"
                                            >
                                                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="quality_control"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-qc-dialog
                ref="qc_dialog"
                @scan-error="$refs.scan_barcode.resetBarcode(true)"
                @scan-close="$refs.scan_barcode.closeBarcode()"
                @scan-open="$refs.scan_barcode.openBarcode()"
                stateProperty="current_qc"
            ></bc-qc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import BcQcDialog from "Modules/manufacturing/quality_control/components/QualityControlDialog";

import app from "Main";

export default {
    data() {
        return {
            last_flagged: null,
            flag_debounce: false,
            flag_timeout: null,
            headers: [
                { text: "", sortable: false, width: "" },
                { text: this.$t("lang.batch_control_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.part_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.qty"), sortable: false, width: "15%" },
                { text: this.$t("lang.microstructure"), sortable: false, width: "15%" },
                { text: this.$t("lang.result"), sortable: false, width: "15%" },
                { text: this.$t("lang.status"), sortable: false, align: "center", width: "" },
            ],
            pass_fail_hold: [
                { text: this.$t("lang.hold"), value: "2", color: "orange" },
                { text: this.$t("lang.pass"), value: "1", color: "green" },
                { text: this.$t("lang.fail"), value: "0", color: "red" },
            ],
            filter: {
                search: "",
                furnace: null,
                page_size: 0,
                page_num: 0,
            },
            mobile_list: [
                // { title: this.$t('lang.add_new'), action: "showQualityControl", ref: "qc_dialog" },
                { title: this.$t("lang.refresh"), action: "dbGetQualityControl" },
            ],
            dbSetQcFlag: _.debounce(this.setQcFlag, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetQualityControl: _.debounce(this.getQualityControl, 1500, { maxWait: 1500, leading: true, trailing: false }),
            furnaces: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (!to.query.furnace) {
            store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    dataProperty: "machines",
                    body: { line_id: 2, slug: "furnace" },
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        app.$router.push({
                            name: to.name,
                            query: {
                                furnace: to.query.furnace ? to.query.furnace : from.query.furnace ? from.query.furnace : data.machines[0].short_code,
                            },
                        });

                        next((vm) => {
                            vm.furnaces = data.machines;
                            vm.finishLoader();
                        });
                    } else {
                        next((vm) => {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    }
                });
        } else {
            store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    dataProperty: "machines",
                    body: { line_id: 2, slug: "furnace" },
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        next((vm) => {
                            vm.furnaces = data.machines;
                        });
                    }
                });

            store
                .dispatch("fetchQualityControl", {
                    url: "quality_control",
                    method: "get",
                    stateProperty: "quality_control",
                    commit: true,
                    body: parsedQuery,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.quality_control) {
                        next((vm) => {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchQualityControl", {
                url: "quality_control",
                method: "get",
                stateProperty: "quality_control",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.quality_control) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_quality_control: (state) => state.validation.rules_quality_control,
            default_filter: (state) => state.quality_control.quality_control_filter,
            page: (state) => state.quality_control.page,
            quality_control: (state) => state.quality_control.quality_control,
            current_qc: (state) => state.quality_control.current_qc,
        }),
        axiosParams() {
            let prep_filter = {};
            prep_filter = JSON.parse(JSON.stringify(this.filter));
            if (!this.filter.furnace) {
                prep_filter.furnace = "";
            }
            return this.prepareParams(prep_filter, this.default_filter);
        },
    },
    methods: {
        getQualityControl(refresh = true) {
            this.startLoader();
            this.$store
                .dispatch("fetchQualityControl", {
                    url: "quality_control",
                    method: "get",
                    stateProperty: "quality_control",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(refresh);
                });
        },
        barcodeScanned(item) {
            this.$refs.scan_barcode.deactivateBarcode();
            this.$refs.qc_dialog.selectBatch(item, true);
        },
        setStatus(batch, status) {
            if (status) {
                this.$store
                    .dispatch("fetchQualityControl", {
                        url: "quality_control/status",
                        method: "patch",
                        body: {
                            batch_id: batch.batch_id,
                            qc_summary: status.value,
                        },
                    })
                    .then((data) => {
                        if (data && data.code == 200) {
                            this.getQualityControl(false);
                        }
                    });
            }
        },
        setQcFlag(batch) {
            if (batch) {
                this.last_flagged = batch.batch_id;
                if (this.flag_timeout) clearTimeout(this.flag_timeout);
                this.flag_timeout = setTimeout(() => {
                    this.last_flagged = null;
                }, 1000);
                this.$store
                    .dispatch("fetchQualityControl", {
                        url: "quality_control/qc_flag",
                        method: "patch",
                        body: {
                            batch_id: batch.batch_id,
                        },
                    })
                    .then((data) => {
                        if (data && data.code == 200) {
                            batch.qc_flag = batch.qc_flag == "1" ? "0" : "1";
                        }
                    });
            }
        },
        setFurnace(value) {
            this.filter.furnace = value;
            this.filterTool(this.axiosParams, false);
        },
    },
    components: {
        BcQcDialog,
    },
};
</script>
